/**
 * Everything the 3D findings viewer shows for one scan — the report's drawer
 * and the standalone 3D page (/report/:id/3d) the kiosk opens beside the QR
 * code. Give it a scan already cut to its sections (limitScanToSections).
 *
 * `sections` is the clinic's scan sections when the scan records them, so the
 * viewer offers only those tabs; null for a scan from before the setting.
 */

import { legPosesOf, postureViewsOf, pressureMapsOf } from './scanModel';
import { findings3d } from './body3dModel';
import { reportSectionsOf } from './reportSections';

export function drawer3dOf(scan, views = postureViewsOf(scan), poses = legPosesOf(scan)) {
  return {
    ...findings3d({
      views, poses, maps: pressureMapsOf(scan), analytics: scan.sensorAnalytics ?? null, chain: scan.analysis?.chain,
      footSize: scan.footSize ?? null, archVitals: scan.archVitals ?? null,
    }),
    sections: scan.scanSections && typeof scan.scanSections === 'object' ? reportSectionsOf(scan) : null,
  };
}
